import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { InfoAttributes, InfoAttributesResponse, Slides } from '../../interface/slides.interface';
import { getSlides } from '../grapql/slides';
import { getCategories, getShopCategories } from '../grapql/categories';
import { mappingProductsByCategory } from '../utils/mappingProducts';
import { getProductByCategory, getProductBySku, getProductBysubCategory } from '../grapql/products';
import { mappingCategoriesShop } from '../utils/mappingCategories';


@Injectable({
  providedIn: 'root'
})
export class ContentService {
  // url = `${environment.apiStrapi}/api`;
  url2 = 'https://us-west-2.cdn.hygraph.com/content/clydpvtzx07mv07ur5n7jjn8f/master';

  constructor(
    private http: HttpClient
  ) { }





  getSlides(): Observable<any> {
    return this.http.post<InfoAttributes>(`${this.url2}`, {query: getSlides()}).pipe(
      map((res: any) => {
        return res.data;
      })
    );
  }
  getCompanyInfo(): Observable<any> {
    return this.http.get(`${this.url2}/info-empresas?populate=*`);
  }

  getCategories(): Observable<any> {
    return this.http.post<InfoAttributes>(`${this.url2}`, {query: getCategories()}).pipe(
      map((res: any) => {
        return res.data.categoriaPrincipals;
      })
    );
  }

  getProductByMainCategories(catalog: string = ''): Observable<any> {
    return this.http.post<InfoAttributes>(`${this.url2}`, {query: getProductByCategory(catalog)}).pipe(
      map((res: any) => {
        return mappingProductsByCategory(res.data.categoriaPrincipals);
      })
    );
  }
  getProductBysubCategories(catalog: string = ''): Observable<any> {
    return this.http.post<InfoAttributes>(`${this.url2}`, {query: getProductBysubCategory(catalog)}).pipe(
      map((res: any) => {
      console.log('****res :', res);
        return (res.data.categoria.producto);
      })
    );
  }
  getCategoriesShop():Observable<any> {
    return this.http.post<InfoAttributes>(`${this.url2}`, {query: getShopCategories()}).pipe(
      map((res: any) => {
        return mappingCategoriesShop(res.data.categoriaPrincipals);
      })
    );
  }
  getProductBySku(sku:string):Observable<any> {
    return this.http.post<any>(`${this.url2}`, {query: getProductBySku(sku)}).pipe(
      map((res: any) => res.data.producto)
    );
  }
}


